<template>
    <transition
        @after-enter="onAfterEnter"
        @enter="onEnter"

        @leave="onLeave"
        @after-leave="onAfterLeave"

        enter-active-class="!overflow-hidden"
        leave-active-class="!overflow-hidden"
    >
        <slot></slot>
    </transition>
</template>

<script>
    export default {
        emits: ['opened', 'closed', 'completed'],

        methods: {
            onAfterEnter(element) {
                element.style.height = `auto`;

                this.$emit('opened')
                this.$emit('completed')
            },

            onAfterLeave(){
                this.$emit('closed')                
                this.$emit('completed')                
            },

            onEnter(element) {
                element.style.height = `auto`;

                const { height } = getComputedStyle(element);

                element.style.height = 0;

                requestAnimationFrame(() => {
                    element.style.height = height;
                });
            },

            onLeave(element) {
                const { height } = getComputedStyle(element);

                element.style.height = height;

                requestAnimationFrame(() => {
                    element.style.height = 0;
                });
            }
        }
    }
</script>